import { CONFERENCE_WILL_JOIN } from '../../../react/features/base/conference/actionTypes';
import { getLocalizedDurationFormatter } from '../../../react/features/base/i18n/dateUtil';
import { JitsiTrackStreamingStatus } from '../../../react/features/base/lib-jitsi-meet';
import { VIDEO_TYPE } from '../../../react/features/base/media/constants';
import { getLocalParticipant, getVirtualScreenshareParticipantOwnerId } from '../../../react/features/base/participants/functions';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { TRACK_ADDED, TRACK_REMOVED, TRACK_UPDATED } from '../../../react/features/base/tracks/actionTypes';
import { isTrackStreamingStatusActive, isTrackStreamingStatusInactive } from '../../../react/features/connection-indicator/functions';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { fixVideoScreenSharing } from './functions';
const streamingStatusByParticipantId = {};
const inactiveStartByParticipantId = {};
let unusedTracks = [];
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case TRACK_ADDED: {
            handleTrackAdded(store, action);
            break;
        }
        case TRACK_UPDATED: {
            const { getState, dispatch } = store;
            const state = getState();
            const { track } = action;
            const { jitsiTrack } = track;
            const isAudioOnly = Boolean(state['features/base/audio-only'].enabled);
            const participantID = jitsiTrack.getParticipantId();
            const prevStreamingStatus = streamingStatusByParticipantId[participantID];
            const streamingStatus = track?.streamingStatus;
            const connectionIndicatorInactiveDisabled = Boolean(state['features/base/config']
                .connectionIndicators?.inactiveDisabled);
            if (isAudioOnly
                || connectionIndicatorInactiveDisabled
                || jitsiTrack.videoType !== VIDEO_TYPE.CAMERA
                || jitsiTrack.isMuted()
                || !streamingStatus
                || streamingStatus === prevStreamingStatus) {
                break;
            }
            const data = {
                participantId: getLocalParticipant(state)?.id,
                trackParticipantId: participantID,
                trackStreamingStatus: streamingStatus,
                inactiveStart: false,
                inactiveEnd: false,
                inactiveDuration: '00:00'
            };
            if (prevStreamingStatus === JitsiTrackStreamingStatus.INACTIVE && isTrackStreamingStatusActive(track)) {
                const diff = Date.now() - inactiveStartByParticipantId[participantID];
                data.inactiveEnd = true;
                data.inactiveDuration = getLocalizedDurationFormatter(diff);
                streamingStatusByParticipantId[participantID] = streamingStatus;
                dispatch(sendStatsToKibana([data], KIBANA_MESSAGES.LowBandwidthByCPU));
            }
            else if (isTrackStreamingStatusInactive(track)) {
                data.inactiveStart = true;
                inactiveStartByParticipantId[participantID] = Date.now();
                streamingStatusByParticipantId[participantID] = streamingStatus;
                dispatch(sendStatsToKibana([data], KIBANA_MESSAGES.LowBandwidthByCPU));
            }
            break;
        }
        case TRACK_REMOVED: {
            const { track } = action;
            unusedTracks.push(track);
            break;
        }
        case CONFERENCE_WILL_JOIN: {
            // Stop unused tracks(video/audio) to avoid camera light or other problems when the user join as a visitor
            if (iAmVisitor(store.getState())) {
                unusedTracks.forEach(t => t?.jitsiTrack?.stopStream?.());
            }
            unusedTracks = [];
            break;
        }
    }
    return next(action);
});
/**
 * Handles track added events, specifically for desktop sharing tracks
 * Sets up event listener to fix video screen sharing when track is muted
 * @param store - Redux store
 * @param action - TRACK_ADDED action
 */
function handleTrackAdded(store, action) {
    const { jitsiTrack } = action.track ?? {};
    if (!jitsiTrack) {
        return;
    }
    const state = store.getState();
    const { participantId } = state['features/large-video'] ?? {};
    const isVisitor = iAmVisitor(state);
    if (!participantId) {
        return;
    }
    const ownerId = getVirtualScreenshareParticipantOwnerId(participantId);
    if (ownerId === jitsiTrack.getParticipantId()
        && jitsiTrack.track && jitsiTrack.getVideoType() === VIDEO_TYPE.DESKTOP) {
        const track = jitsiTrack.track;
        // Create a local reference to jitsiTrack
        const trackRef = jitsiTrack;
        // Add event listener to fix video screen sharing when track is muted
        track.addEventListener('mute', () => {
            fixVideoScreenSharing(trackRef, isVisitor);
        });
    }
}
